import axios from "axios";
import { API_BASE_URL } from "../constants";
import { logError } from "../common/utils/logger";

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

api.interceptors.request.use(
  async (config) => {
    config.headers = config.headers || {};
    if (window.Liferay?.authToken) {
      config.headers["X-CSRF-Token"] = window.Liferay.authToken;
    }
    return config;
  },
  Promise.reject,
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status;
    const config = error?.config;
    if (
      config &&
      (status === 401 || status === 403) &&
      (config._retryCount || 0) < 2
    ) {
      config._retryCount = (config._retryCount || 0) + 1;
      return api(config);
    }
    logError("[DropoffRecoveryJourney][API] request failed", {
      url: config?.url,
      status,
      data: error?.response?.data,
    });
    throw error;
  },
);

export default api;
